import { ConfigProvider } from 'antd';
import React, { PropsWithChildren } from 'react';
import es_ES from 'antd/locale/es_ES';
import en_US from 'antd/locale/en_US';
import pt_BR from 'antd/locale/pt_BR';
import ru_RU from 'antd/locale/ru_RU';
import { Locale as AntLocale } from 'antd/es/locale';
import { useTranslation } from 'react-i18next';

export const AntConfigProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { i18n } = useTranslation();

  const currentLang = i18n.language.split(/[-_]/)[0];

  const antLocaleByLanguage: Record<string, AntLocale> = {
    en: en_US,
    es: es_ES,
    pt: pt_BR,
    ru: ru_RU,
  };

  return (
    <ConfigProvider
      locale={antLocaleByLanguage[currentLang] || en_US}
      theme={{
        components: {
          Layout: {
            bodyBg: '#ffffff',
          },
        },
        token: {
          borderRadius: 8,
          colorBgBase: '#f4f9fc',
          colorPrimary: '#2B2B2B',
          colorTextBase: '#505050',
          fontFamily: 'Inter',
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
